import { Amplify } from 'aws-amplify';
import { Provider } from 'react-redux';

import 'src/shared/i18n';

import { ExperienceGate } from '@/console/host/experience-gate';
import { amplifyConfiguration } from '@/shared/aws-export';
import store from '@/shared/redux/store/store';

Amplify.configure(
  amplifyConfiguration({
    userPoolId: import.meta.env.VITE_APP_AWS_USER_POOLS_ID,
    userPoolClientId: import.meta.env.VITE_APP_AWS_USER_POOLS_WEB_CLIENT_ID,
  }),
);

export const App = () => (
  <Provider store={store}>
    <ExperienceGate />
  </Provider>
);
